import React from 'react';
import { isMobileView } from '../../Common/utils';

export default function SortBy(props){
    const mobileView = isMobileView();

    return (<div className="sortByWrapper">
    <div className="sortByHeading">
        <span className="sortByTxtSpan">Sort by:</span>
    </div>
    <div className="sortBySortingFilters" onClick={props.onClick}>
        <span className="sortByFilterstxtSpan active" data-val={mobileView ?"relevance" : "best"}>BEST</span>
        <span className="sortByFilterstxtSpan" data-val={mobileView ?"rating" : "rating_high"}>RATING</span>
        <span className="sortByFilterstxtSpan" data-val={mobileView ? "depart_asc" : "late_departure"}>DEPARTURE</span>
        <span className="sortByFilterstxtSpan desktopOnly" data-val={"late_arrival"}>ARRIVAL</span>
        <span className="sortByFilterstxtSpan" data-val={mobileView ? "fastest" :"high_speed"}>FASTEST</span>
        <span className="sortByFilterstxtSpan" data-val={mobileView ? "price_asc" :"high_price"}>CHEAPEST</span>
        </div>
    </div>)
}

